import { render, staticRenderFns } from "./pageSidebar.vue?vue&type=template&id=6e4cdfdd&scoped=true&"
import script from "./pageSidebar.vue?vue&type=script&lang=js&"
export * from "./pageSidebar.vue?vue&type=script&lang=js&"
import style0 from "./pageSidebar.vue?vue&type=style&index=0&id=6e4cdfdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4cdfdd",
  null
  
)

export default component.exports